<template>
  <!-- <div class="sidebar-form"></div> -->
  <b-form class="form">
    <b-input-group>
      <b-form-input placeholder="Search..."></b-form-input>
      <b-input-group-button>
        <b-btn variant="none"><i class="fa fa-search"></i></b-btn>
      </b-input-group-button>
    </b-input-group>
  </b-form>
</template>
<script>

export default {
  name: 'sidebar-form'
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Sidebar/SidebarForm.vue